import TMCalculator from './TMCalculator_v2';
export default function App() { return <TMCalculator />; }